import {
  createRecProductVideoComponents,
  RecProduct,
  RecProductProps,
} from '@pro-page-components/rec-product';
import { useChildrenVisibilityEditor } from '@pro-page-components/utils/useChildrenVisibility';
import * as React from 'react';
import { ComponentForEditor } from 'react-page-editor/state';

import config from './config.json';
import defaultProps from './defaultProps.json';

const { Video, VideoEditor } = createRecProductVideoComponents({
  name: 'REC Alpha Pure 2 Series Video',
  id: 'REC_ALPHA_PURE_2_VIDEO',
  path: '.....',
  parent: config.id,
});

export const RecAlphaPure2Series: ComponentForEditor<RecProductProps> = (
  props: RecProductProps,
) => <RecProduct VideoComponent={Video} {...props} />;

export const RecAlphaPure2SeriesEditor: ComponentForEditor<RecProductProps> = (
  props: RecProductProps,
) => {
  // eslint-disable-next-line no-underscore-dangle,react/destructuring-assignment
  const visible = useChildrenVisibilityEditor(props.__config);
  if (!visible) return null;
  return (
    <RecAlphaPure2Series
      scale={0.9}
      skipVisibilityCheck
      VideoComponent={VideoEditor}
      {...props}
    />
  );
};

RecAlphaPure2Series.children = [Video];
RecAlphaPure2Series.defaultProps = defaultProps as RecProductProps;
RecAlphaPure2Series.config = config;
RecAlphaPure2SeriesEditor.defaultProps = defaultProps as RecProductProps;
RecAlphaPure2SeriesEditor.config = config;
RecAlphaPure2SeriesEditor.children = [VideoEditor];
